import { render } from "./LivraisonDomicile.vue?vue&type=template&id=024c41ae&scoped=true"
import script from "./LivraisonDomicile.vue?vue&type=script&lang=js"
export * from "./LivraisonDomicile.vue?vue&type=script&lang=js"

import "./LivraisonDomicile.vue?vue&type=style&index=0&id=024c41ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024c41ae"]])

export default __exports__